import PropTypes from 'prop-types';
import React, { Component } from 'react';
//import get from 'lodash/get';
// import cn from 'classnames';
// import css from './css.css';
// import Spinner from '../Spinner/Spinner';
import { Spinner } from "./Spinner";
import { Center } from "~/native-ui/native-base";
import { Input } from "~/native-ui/Input";

export const SpinnerInput = (() => {
	class SpinnerInput extends Component {
		static propTypes = {
			loading: PropTypes.bool
		};
	
		getRightIcon() {

			if (!this.props.loading) {
				return this.props.iconRight;
			}
	
			return (
				<Center height={10} width={10}>
					<Spinner size="xs" />
				</Center>
			)
		}
	
		render() {
			const { loading, forwardedRef, ...props } = this.props;

			const inputProps = {
				...props,
				ref: forwardedRef,
				iconRight: <React.Fragment>{ this.getRightIcon() }</React.Fragment>
			}

			return (
				<Input { ...inputProps } />
			);
		}
	}

	return React.memo(React.forwardRef((props, ref) => {
		return <SpinnerInput { ...props } forwardedRef={ref} />
	}))
})()